import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { Role } from '../../../models/role.model';

@Component({
  selector: 'app-role-detail',
  templateUrl: './role-detail.component.html'
})
export class RoleDetailComponent {

  roleId: number;
  role: Role;

  constructor(
    private route: ActivatedRoute,
    private location: Location
  ) {
    this.roleId = +this.route.snapshot.params.roleId;
    this.route.data.subscribe(data => {
      this.role = data.roleResolverResponse;
    });
  }

  back() {
    this.location.back();
  }

}
